import { Box, Skeleton, Stack } from "@mui/material";

export type ProjectTabSkeletonVariant =
  | "details"
  | "tools"
  | "users"
  | "costs"
  | "history";

interface ProjectTabSkeletonProps {
  variant: ProjectTabSkeletonVariant;
}

const rootSx = {
  pl: "80px",
  pt: "24px",
  width: "100%",
  minHeight: 0,
  boxSizing: "border-box",
  overflowX: "hidden",
};

const ProjectTabSkeleton = ({ variant }: ProjectTabSkeletonProps) => {
  if (variant === "history") {
    return (
      <Box sx={rootSx}>
        <Skeleton variant="text" width={120} height={34} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={280} height={24} sx={{ mb: 3 }} />
        <Stack spacing={1.5}>
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
          ))}
        </Stack>
      </Box>
    );
  }

  if (variant === "costs") {
    return (
      <Box sx={rootSx}>
        <Skeleton variant="text" width={120} height={34} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={340} height={24} sx={{ mb: 3 }} />
        <Stack spacing={2}>
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" height={52} sx={{ borderRadius: 1 }} />
          ))}
        </Stack>
      </Box>
    );
  }

  if (variant === "tools") {
    return (
      <Box sx={rootSx}>
        <Skeleton variant="text" width={160} height={34} sx={{ mb: 2 }} />
        <Stack spacing={2.5} sx={{ width: "100%", maxWidth: 1100 }}>
          <Skeleton variant="rectangular" height={72} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={72} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={72} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={240} sx={{ borderRadius: 1 }} />
        </Stack>
      </Box>
    );
  }

  if (variant === "users") {
    return (
      <Box sx={rootSx}>
        <Skeleton variant="text" width={160} height={34} sx={{ mb: 2 }} />
        <Stack spacing={2} sx={{ width: "100%", maxWidth: 1200 }}>
          <Skeleton variant="rectangular" height={72} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={72} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={72} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={360} sx={{ borderRadius: 1 }} />
        </Stack>
      </Box>
    );
  }

  return (
    <Box sx={rootSx}>
      <Skeleton variant="text" width={180} height={34} sx={{ mb: 2 }} />
      <Stack spacing={2} sx={{ width: "100%", maxWidth: 1100 }}>
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
      </Stack>
    </Box>
  );
};

export default ProjectTabSkeleton;
